export default __webpack_public_path__ + "static/media/instagram.fcd5dd2b.svg";